type NumFormatOptions = {
  keepFractions?: boolean;
  fractionDigits?: number;
  hideFractIfInteger?: boolean;
};


function FormatWithThousandSeparator(value?: number | string | null, options?: NumFormatOptions) {
  const num = Number(value);

  if (!Number.isFinite(num)) {
    return 'N/A';
  }

  let stringifiedValue: string;

  if (options?.keepFractions) {
    stringifiedValue = num.toString();
  }
  else if (options?.hideFractIfInteger) {
    const [int, fract] = num.toString().split('.');
    stringifiedValue = fract ? num.toString() : int;
  }
  else if (typeof options?.fractionDigits === 'number') {
    stringifiedValue = num.toFixed(options.fractionDigits);
  }
  else {
    stringifiedValue = num.toFixed(2);
  }

  const decimalPointIndex = stringifiedValue.indexOf('.');

  return stringifiedValue.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) =>
    decimalPointIndex < 0 || i < decimalPointIndex ? `${m},` : m,
  );
}


export { FormatWithThousandSeparator };